// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3what","question":"Question_question__274jb","description":"Question_description__3CKB6"};